import React from 'react';
import PropTypes from 'prop-types';

import { Wait } from './wait.jsx';

export const ImplicitWait = ({ wait, hide }) => {
    const visible = !hide && wait && wait.get('waiting') && wait.get('visible');
    return (
        <Wait
            message="Please Wait..."
            transparent={true}
            visible={visible}
            fadeIn={true}
            fadeOut={true}
        />
    );
};

/**
 * wait - implicit wait state. Contains waiting (bool) and visible (bool).
 * hide - if true, hide everything.
 */
ImplicitWait.propTypes = {
    wait: PropTypes.object,
    hide: PropTypes.bool,
};

ImplicitWait.displayName = 'ImplicitWait';

export default ImplicitWait;
